import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import { SubscriptionTagsType } from 'root-constants'

export const useRoundedSubscriptionTags = (
  baseSubscriptionTags: string,
): string => {
  const { isAyah94LocalPricesTestGroup } = useExperimentalFeatures()

  return isAyah94LocalPricesTestGroup
    ? `${baseSubscriptionTags},${SubscriptionTagsType.ROUNDING}`
    : baseSubscriptionTags
}
